import React, { useEffect } from "react";
import ToggleButtonGroup from "../../../sharedComponents/toggleButtonGroup/toggleButtonGroup";
import { inject, observer } from "mobx-react";
import { ClientStore } from "../../../../stores/clientStore";
import { ProposalStore } from "../../../../stores/proposalStore";
import { CalculateStore } from "../../../../stores/calculateStore";
import { yesNo } from "../../../../helpers/yesNo";
import { PaymentMethodTypes } from "../../../../helpers/paymentMethod";
import { UiFlagsStore } from "../../../../stores/uiFlagsStore";

interface DistancePolicyProps {
  clientStore?: ClientStore;
  calculateStore?: CalculateStore;
  proposalStore?: ProposalStore;
  uiFlagsStore?: UiFlagsStore;
  isDistancePolicyRequired: boolean;
}

export function DistancePolicy(props: DistancePolicyProps) {
  const clientStore = props.clientStore!;
  const proposalStore = props.proposalStore!;
  const calculateStore = props.calculateStore!;
  const uiFlagsStore = props.uiFlagsStore!;
  const question = "Zawarcie polisy na odległość?";

  useEffect(() => {
    if (props.isDistancePolicyRequired) {
      validate(true);
      proposalStore.setPaymentMethod(PaymentMethodTypes.TRANSFER);
    }
  });

  return (
    <div className="section distance-policy">
      <ToggleButtonGroup
        question={question}
        options={[
          {
            value: yesNo.yes,
            label: "tak"
          },
          {
            value: yesNo.no,
            label: "nie"
          }
        ]}
        errorMessage={proposalStore.distancePolicy.errorMessage}
        value={setButtonValue()}
        onChange={onChangeValue}
        disabled={props.isDistancePolicyRequired}
      />
    </div>
  );

  function onChangeValue(newValue: string | undefined) {
    const distancePolicy = newValue === yesNo.yes;
    proposalStore.distancePolicy.setValue(distancePolicy);
    if (distancePolicy && proposalStore.paymentMethod !== PaymentMethodTypes.TRANSFER) {
      proposalStore.setPaymentMethod(PaymentMethodTypes.TRANSFER);
    }
    validate(distancePolicy);
  }

  function validate(distancePolicy: boolean) {
    proposalStore.distancePolicy.validate();
    validateDistancePolicyOptionalFields(distancePolicy);
    proposalStore.setAllRequiredConsentsCheckbox(
      proposalStore.checkIfAllRequiredConsentsChecked(calculateStore, uiFlagsStore.isDirect)
    );
  }

  function validateDistancePolicyOptionalFields(distancePolicy: boolean) {
    if (!distancePolicy) {
      clientStore.insurer.validateEmail(!!proposalStore.distancePolicy.value);
      clientStore.insurer.validatePhoneNumber(!!proposalStore.distancePolicy.value);
    }
  }

  function setButtonValue() {
    const distancePolicy = proposalStore.distancePolicy.value;
    if (distancePolicy === undefined) {
      return undefined;
    }
    return distancePolicy ? yesNo.yes : yesNo.no;
  }
}

export default inject("clientStore", "proposalStore", "calculateStore", "uiFlagsStore")(observer(DistancePolicy));
